<template>
  <div v-show="panelShow">
    <Col :xs="24" :sm="24" :md="12" :lg="colSpanBig" :style="{padding: '5px'}">
      <alarmLogsEventsModal ref="alarmLogsEventsModal"></alarmLogsEventsModal>
      <Card shadow style="height: 330px" class="home-card">
        <div slot="title">
          <font-awesome-icon icon="info-circle" style="color: red" /><b> 正在告警</b>
          <router-link style="float: right" :to="{ name: 'alarm_logs' }">详情</router-link>
        </div>
        <div>
          <Alert v-if="error" type="warning" show-icon class="alarm-list-alert-warning">获取告警数据失败</Alert>
          <Spin fix v-else-if="eventCasesTableProblemLoading" class="home-component-loading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>加载中</div>
          </Spin>
          <Alert type="success" show-icon v-else-if="!data.length" class="alarm-list-alert-success">
            <span>当前无告警信息</span>
          </Alert>
          <GeminiScrollbar class="logs-scroll-bar alarm-list-logs-scroll-bar" :style="{height: '250px'}" v-else>
            <div style="padding-right: 10px;">
              <Alert type="error" v-for="(item, index) in data" :key="'alarm_list_data_key_' + index" class="alarm-list-alert-error">
                <div style="width: 70%" class="data-alert">
                  <span>{{ item.endpoint }} - {{ item.metric_name }}</span>
                </div>
                <div style="float: right;" class="ivu-alert-close">
                  <span style="color: #fff; margin-right: 5px">{{ daysBetween(item.timestamp) }}</span>
                  <a v-on:click="eventsModalOpen(item)">查看</a>
                </div>
              </Alert>
            </div>
          </GeminiScrollbar>
        </div>
      </Card>
    </Col>
  </div>
</template>

<script>
import alarmLogsEventsModal from '../../../view/monitor/components/alarm-logs-events-modal'
import { getEventCases } from '@/api/monitor'
import { getDaysBetween } from '@/libs/timeTools'

export default {
  name: 'alarm-list',
  components: {
    alarmLogsEventsModal
  },
  props: {
    panelShow: {
      type: Boolean,
      default: true
    },
    colSpanBig: {
      type: Number,
      default: 8
    }
  },
  data () {
    return {
      error: false,
      eventCasesTableProblemLoading: false,
      data: []
    }
  },
  watch: {
    panelShow () {
      if (this.panelShow) {
        this.getEventCasesProblemData()
      }
    }
  },
  created: function () {
    if (this.panelShow) {
      this.getEventCasesProblemData()
    }
  },
  methods: {
    getEventCasesProblemData () {
      let params = {
        is_paginator: false,
        status: 'PROBLEM'
      }
      this.eventCasesTableProblemLoading = true
      this.data = []
      getEventCases(params).then(res => {
        let data = res.data.data
        this.data = data
        this.eventCasesTableProblemLoading = false
      }).catch(res => {
        this.eventCasesTableProblemLoading = false
        this.error = true
      })
    },
    daysBetween (sDate1) {
      return getDaysBetween(sDate1)
    },
    eventsModalOpen (row) {
      this.$refs.alarmLogsEventsModal.eventsModalOpen(row)
    }
  }
}
</script>

<style scoped>
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
  .data-alert {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .alarm-list-alert-error {
    background-color: rgba(225, 77, 66, 0.6);
    border: unset;
    color: #fff;
  }
  .alarm-list-alert-warning {
    background-color: rgba(244, 114, 11, 0.6);
    border: unset;
    color: #fff;
  }
  .alarm-list-alert-success {
    background-color: rgba(0, 255, 0, 0.5);
    border: unset;
    color: #fff;
  }
</style>
<style>
  .alarm-list-logs-scroll-bar .-vertical {
    background-color: rgba(255, 255, 255, 0.05);
  }
  .alarm-list-logs-scroll-bar .gm-scrollbar .thumb {
    background-color: rgba(255, 255, 255, 0.6);
  }
</style>
